export interface AppData {
    id: string;
    name: string;
    description: string;
    icon: string;
    status: {
        platform: string;
        version: string;
        status: string;
    }[];
    features: string[];
    screenshots: string[];
    videos: string[];
    appStoreLink?: string;
    googlePlayLink?: string;
    webLink?: string;
    // Smart links (/app/<id>?redirect=true) for this app send people to this app instead.
    redirectTo?: string;
    customHero?: {
        imageUrl: string;
        titleColor: string;
        descColor: string;
    }
}

export const apps: AppData[] = [
    {
        id: "shiftwave",
        name: "ShiftWave",
        description: "The repeating shift schedule calendar for police, fire, EMS, nurses and anyone on a rotation.",
        icon: "/images/shiftwave/app_icon_256.png",
        status: [
            { platform: "iOS", version: "1.4", status: "Available" },
            { platform: "Android", version: "1.4", status: "Available" }
        ],
        features: [
            "Any repeating rotation: 4-on-4-off, Pitman, DuPont, 2-2-3 and more",
            "720+ ready-made schedule templates",
            "4-digit Quick Setup codes to load your department's schedule",
            "Color-coded days with automatic text highlighting",
            "Notes, overtime, court dates and shift swaps on any day",
            "Home screen widget with this week's shifts",
            "Built-in holidays you can pick and choose",
            "Export to Apple Calendar, Google Calendar and more",
            "Dark mode and colorful themes"
        ],
        screenshots: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/images/shiftwave/ios/0${n}@2x.jpg`),
        videos: ["/images/shiftwave/video_1.mp4"],
        appStoreLink: "https://apps.apple.com/us/app/shiftwave-repeating-schedule/id6742365343",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.myprojectx.shiftwave"
    },
    {
        id: "copapp",
        name: "CopApp!",
        description: "The original rotating shift calendar. Throw out your old paper schedule and use this app instead!",
        icon: "/images/copapp/app_icon_256.png",
        status: [
            { platform: "iOS", version: "2.12", status: "Available" },
            { platform: "Android", version: "2.12", status: "Available" }
        ],
        features: [
            "Rotating calendar for any repeating schedule",
            "Load your rotation from a list of schedule templates",
            "Quick Setup codes to load a predefined schedule",
            "Share your schedule setup with a link or QR code",
            "Highlight days by text, like squads 1/2",
            "Notes on any date",
            "Light, Gray and Dark themes",
            "Jump to today and choose the first day of the week"
        ],
        // The old files in /images/copapp are ShiftWave screens, so none are shown.
        screenshots: [],
        videos: [],
        appStoreLink: "https://apps.apple.com/us/app/copapp-!-calendar-schedule/id505736737",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.myprojectx.copapp",
        // ShiftWave is the next generation of CopApp!, so old CopApp! links go there.
        redirectTo: "shiftwave"
    }
];
